import { METHOD_TYPES } from 'utils/constants/index'
import axiosInstanceService from 'network/apis/index'
import { microServices } from 'network/apis/microservice/index'

export const placeBetPlinkoGameService = (data) => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/plinko-game/place-bet', data, {
    server: microServices.SERVICE_URL_1
  })
}

export const getMyBetsPlinkoService = (params) => {
  return axiosInstanceService(METHOD_TYPES.get, '/fast-games/plinko-game/my-bets', {}, {
    params,
    server: microServices.SERVICE_URL_1
  })
}

export const postLightningBoardDetailsService = () => {
  return axiosInstanceService(METHOD_TYPES.post, '/fast-games/plinko-game/lightning-board-details', {}, {
    server: microServices.SERVICE_URL_1
  })
}
